export default function lazyLoadIframeInModal(iframe, callback = undefined) {
  const observeVideo = elements => {
    const entry = elements[0];

    if (entry.isIntersecting) {
      const el = entry.target;
      const { modalIframeSrc } = el.dataset;

      if (modalIframeSrc) {
        el.src = modalIframeSrc;
        el.removeAttribute('data-modal-iframe-src');

        if (callback) {
          callback.call();
        }
      }
    }
  };

  const observer = new IntersectionObserver(observeVideo);
  observer.observe(iframe);
}
